export const route = [
  { title: 'home', id: 1 },
  { title: 'detail1', id: 2 },
  { title: 'detail2', id: 3 },
  { title: 'detail3', id: 4 }
];
